export const CONSENT_KEY = "qst_cookie_consent";
export const CONSENT_EVENT = "qst-consent-change";

export const GA_MEASUREMENT_ID = "G-SNK0ZSYFV2";
export const ADSENSE_CLIENT = "ca-pub-7304996575143508";

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  const payload = {
    analytics: Boolean(value.analytics),
    advertising: Boolean(value.advertising),
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(payload));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: payload }));
  return payload;
}

export function hasAnalyticsConsent(consent = getConsent()) {
  return Boolean(consent?.analytics);
}

export function hasAdvertisingConsent(consent = getConsent()) {
  return Boolean(consent?.advertising);
}

function loadScript(src, attrs = {}) {
  if (document.querySelector(`script[src="${src}"]`)) return;
  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  Object.entries(attrs).forEach(([key, val]) => {
    script.setAttribute(key, val);
  });
  document.head.appendChild(script);
}

export function applyConsentScripts(consent = getConsent()) {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  if (hasAnalyticsConsent(consent)) {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`);
    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, { anonymize_ip: true });
    window.gtag("consent", "update", {
      analytics_storage: "granted",
    });
  } else {
    window.gtag("consent", "update", {
      analytics_storage: "denied",
    });
  }

  if (hasAdvertisingConsent(consent)) {
    loadScript(
      `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`,
      { crossorigin: "anonymous" }
    );
    window.gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
  } else {
    window.gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
}
